// extracted by mini-css-extract-plugin
export default {"tabs":"add_activity_profiles_modal-module___tabs___b08fe2b7"};